import type { PersonDirectoryAction } from "../types/personDirectoryAccess.js";
import type { Role } from "../types/user.js";

const personDirectoryActionsByRole: Record<
  Role,
  readonly PersonDirectoryAction[]
> = {
  organisation_admin: ["search", "match", "create"],
  responsible_user: ["search", "match", "create"],
  assessor: ["search"],
  approver: ["search"],
  viewer: ["search"],
  thalamos_admin: [],
};

/**
 * What a role may do in the person directory of the organisation a session
 * acts for. Keyed by `Role`, so a new role fails to compile until it says what
 * it may do here.
 *
 * Creating goes to the roles that may allocate a responsible user, because
 * whoever creates a person's record allocates its first responsible user.
 * Matching is the check made before creating, so it goes wherever `create`
 * does.
 */
export const personDirectoryActionsPermittedByRole = (
  role: Role,
): readonly PersonDirectoryAction[] => personDirectoryActionsByRole[role];
